"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetWlfIDs = GetWlfIDs;
exports.GetWlfIDsC = GetWlfIDsC;
exports.GetWlfItem = GetWlfItem;
exports.GetWlfItemC = GetWlfItemC;
exports.UpdateWlfItemPaths = UpdateWlfItemPaths;
exports.UpdateWlfItemPathsC = UpdateWlfItemPathsC;
var response_1 = require("@ca/wrap-sdk/src/response");
var env_1 = require("@ca/wrap-sdk/src/env");
var aws_dynamo_1 = require("@ca/wrap-sdk/src/aws-dynamo");
function GetWlfTable() {
    return env_1.Stage.stage + "-WLF";
}
function GetWlfIDs() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, GetWlfIDsC(null)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function GetWlfIDsC(creds) {
    return __awaiter(this, void 0, void 0, function () {
        var table, resp, items;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    table = GetWlfTable();
                    return [4 /*yield*/, (0, aws_dynamo_1.QueryAllC)(creds, table, "wlf", null, null, null, null)];
                case 1:
                    resp = _a.sent();
                    if (resp.status === response_1.Status.ERROR) {
                        return [2 /*return*/, resp];
                    }
                    items = resp.payload;
                    return [2 /*return*/, (0, response_1.SuccessResponse)(items.map(function (item) { return item.id; }))];
            }
        });
    });
}
function GetWlfItem(wlf_id_1) {
    return __awaiter(this, arguments, void 0, function (wlf_id, partition) {
        if (partition === void 0) { partition = "wlf"; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, GetWlfItemC(null, wlf_id, partition)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function GetWlfItemC(creds_1, wlf_id_1) {
    return __awaiter(this, arguments, void 0, function (creds, wlf_id, partition) {
        var table, key, resp, items;
        if (partition === void 0) { partition = "wlf"; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    table = GetWlfTable();
                    key = {
                        partition: partition,
                        id: wlf_id,
                    };
                    return [4 /*yield*/, (0, aws_dynamo_1.BatchC)(creds, table, [key])];
                case 1:
                    resp = _a.sent();
                    if (resp.status === response_1.Status.ERROR) {
                        return [2 /*return*/, resp];
                    }
                    items = resp.payload;
                    if (items.length === 0) {
                        return [2 /*return*/, (0, response_1.ErrorResponse)("Can't find item")];
                    }
                    return [2 /*return*/, (0, response_1.SuccessResponse)(items[0])];
            }
        });
    });
}
function UpdateWlfItemPaths(partition, wlf_id, paths) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, UpdateWlfItemPathsC(null, partition, wlf_id, paths)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function UpdateWlfItemPathsC(creds, partition, wlf_id, paths) {
    return __awaiter(this, void 0, void 0, function () {
        var table, key;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (partition === "wlf") {
                        return [2 /*return*/, (0, response_1.ErrorResponse)("Can't write wlf partition")];
                    }
                    table = GetWlfTable();
                    key = {
                        partition: partition,
                        id: wlf_id,
                    };
                    return [4 /*yield*/, (0, aws_dynamo_1.UpdatePathsC)(creds, table, key, paths, "ALL_NEW")];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
//# sourceMappingURL=wlf-item.js.map